export default __webpack_public_path__ + "static/media/035-cctv camera.96b54671.svg";